import React from "react";
import xstream from "state-x-stream";
import PropTypes from "prop-types";
import { debounceTime, distinctUntilChanged, map, switchMap } from "rxjs";
import ZoomService from "../../services/zoomService/zoom.service";
import Btn from "../../../../components/atoms/Btn";

function controller({ props$ }) {
  return {
    isInverted: props$.pipe(
      switchMap(({ zoomService: zs }) => zs.isInverted$),
      debounceTime(50)
    ),
    isWholeGenome: props$.pipe(
      switchMap(({ zoomService: zs }) => zs.isWholeGenome$)
    ),
    width: props$.pipe(
      switchMap(({ zoomService: zs }) => zs.xScale$),
      map(({ r1 }) => r1 - 5),
      map((x) => `${x}px`),
      distinctUntilChanged()
    ),
  };
}

function XAxisInfo({ isInverted, zoomService, width, isWholeGenome }) {
  const rgbTransition = "tw-transition-colors transition-duration-200";
  const invClass = isInverted ? "tw-bg-red-600 tw-text-white" : "bg-1 color-1";
  const strand = isInverted ? "-1" : " 1";

  return (
    <div className={`bg-1 color-1 ${rgbTransition} tw-text-3xs`}>
      <div
        style={{ width }}
        className="bg-1 tw-border-l border-2 tw-absolute tw-top-0 tw-right-0 tw-bottom-0"
      >
        <div className="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
          <div
            onClick={() => zoomService.setIsWholeGenome(!isWholeGenome)}
            className="tw-cursor-pointer"
            role="button"
          >
            {isWholeGenome ? "show 1" : "show all"}
          </div>
        </div>
      </div>
      <div
        style={{ width }}
        className={`bg-1 tw-absolute tw-flex tw-justify-center tw-items-center tw-top-0 tw-left-0 tw-bottom-0 ${rgbTransition}`}
      >
        <div className={`${invClass} ${rgbTransition} tw-rounded-sm tw-p-1`}>
          <Btn onSubmit={zoomService.toggleInversion} title="toggle strand">
            <div>strand: {strand}</div>
            {isInverted ? (
              <div className="tw-text-center">&#8592; &#8592; &#8592;</div>
            ) : (
              <div className="tw-text-center">&#8594; &#8594; &#8594;</div>
            )}
          </Btn>
        </div>
      </div>
    </div>
  );
}

XAxisInfo.propTypes = {
  isInverted: PropTypes.bool,
  zoomService: PropTypes.instanceOf(ZoomService).isRequired,
  width: PropTypes.string,
  isWholeGenome: PropTypes.bool,
};

XAxisInfo.defaultProps = {
  width: "0px",
  isInverted: false,
  isWholeGenome: false,
};

export default xstream(controller)(XAxisInfo);
